export default {
  fallback: "The request failed. Please try again later.",
  network: "Could not reach the server. Check your connection.",
  http_400: "The request was invalid.",
  http_401: "Your session expired. Please sign in again.",
  http_403: "You do not have permission for this action.",
  http_404: "Not found.",
  http_409: "Conflicted with another operation. Reload and try again.",
  http_500: "A server error occurred.",
  http_503: "The server is temporarily unavailable.",
  missing_form_file: "This task cannot be completed from this screen.",
  error_suspended: "The case is suspended and cannot be updated.",
} as const;
